export interface Testimonial {
  name: string
  role: string
  location: string
  age: number
  headline: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Megan Holloway',
    role: 'Agronomist',
    location: 'Saskatoon, Saskatchewan, Canada',
    age: 41,
    headline: 'Identifying nutrient symptoms feels much more organized.',
    quote:
      'Different nutrient deficiencies can look surprisingly similar. Having structured visual comparisons makes it easier to organize observations and determine what needs further investigation.',
  },
  {
    name: 'Daniel Price',
    role: 'Agricultural Technician',
    location: 'Lincolnshire, United Kingdom',
    age: 29,
    headline: 'The crop-specific visual references are extremely practical.',
    quote:
      "Looking at general deficiency charts isn't always enough. Having symptom references organized by crop type makes the material much more useful for agricultural assessments.",
  },
  {
    name: 'Laura Bennett',
    role: 'Crop Nutrition Consultant',
    location: 'Fresno, California, United States',
    age: 46,
    headline: 'Much better than scattered agronomy references.',
    quote:
      'I regularly work with soil reports, tissue analysis, crop photographs, and fertilizer records. Having these references organized in one system is very convenient.',
  },
  {
    name: 'Mark Sullivan',
    role: 'Crop Advisor',
    location: 'Wagga Wagga, New South Wales, Australia',
    age: 52,
    headline: 'A valuable resource for field assessments.',
    quote:
      'Recognizing a symptom is only the beginning. The structured worksheets help organize observations, evaluate possible nutritional causes, and document the next steps.',
  },
  {
    name: 'Peter van Dijk',
    role: 'Commercial Grower',
    location: 'Leamington, Ontario, Canada',
    age: 44,
    headline: 'A professional visual resource I can keep using.',
    quote:
      'The nutrient deficiency comparisons, crop-specific references, sampling tools, and field documentation templates make this a practical resource to return to during different crop assessments.',
  },
]
